import React, { useRef, useState } from 'react';
import Slider from 'react-slick';

const VirtualTourBanner = () => {
    const sliderRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);

    const next = () => {
        sliderRef.current.slickNext();
    };

    const previous = () => {
        sliderRef.current.slickPrev();
    };

    const handleBeforeChange = (oldIndex, newIndex) => {
        setCurrentIndex(newIndex);
    };

    const handleAfterChange = (current) => {
        setCurrentIndex(current);
    };

    const handleArrowClick = (direction) => {
        if (direction === "left") {
            previous();
        } else if (direction === "right") {
            next();
        }
    };


    const settings = {
        centerMode: true,
        infinite: true,
        centerPadding: "0px",
        slidesToShow: 1,
        speed: 1500,
        easing: 'ease-out',
        beforeChange: handleBeforeChange,
        afterChange: handleAfterChange,
        responsive: [
            {
                breakpoint: 1279,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    const carousles = [
        { image1: "https://www.renderatelier.com/360/GPP8/Designer_Suite/", image2: "https://greendirectorydata.s3.us-east-2.amazonaws.com/C4-1.jpg", text1: "Designer ", text2: "Suite", head: "DS" },
        { image1: "https://www.renderatelier.com/360/GPP8/1B_Townhouse/", image2: "https://greendirectorydata.s3.us-east-2.amazonaws.com/C3-04.jpg", text1: "One Bedroom ", text2: "TownHouse", head: "1BT" },
        { image1: "https://www.renderatelier.com/360/GPP8/1B_Penthouse/", image2: "https://greendirectorydata.s3.us-east-2.amazonaws.com/C3-02.jpg", text1: "One Bedroom ", text2: "PentHouse", head: "1BP" },
        { image1: "https://www.renderatelier.com/360/GPP8/2B_Penthouse/", image2: "https://greendirectorydata.s3.us-east-2.amazonaws.com/C2-01.jpg", text1: "Two Bedroom ", text2: "PentHouse", head: "2BP" },
        { image1: "https://www.renderatelier.com/360/GPP8/2B_Villa/", image2: "https://greendirectorydata.s3.us-east-2.amazonaws.com/C2-01%20%281%29.jpg", text1: "Two Bedroom", text2: " Sky Villa", head: "2BSV2" },
    ];

    return (
        <div className='main-virtual-tour-bg-clr'>
            <div className='container'>
                <div className='virtual-tour-main-div'>
                    <div className='virtual-tour-left-div'>
                        <div className='top-text'>
                            <h4>Virtual Tour</h4>
                        </div>
                        <div className='middle-text'>
                            <h6>{carousles[currentIndex].text1}</h6>
                            <h2>{carousles[currentIndex].text2}</h2>
                        </div>
                        <div className='arrow-div'>
                            <div className='arrow'>
                                <button onClick={() => handleArrowClick("left")}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="12" viewBox="0 0 23 12" fill="none">
                                        <path d="M22 6.72089C22.4142 6.72089 22.75 6.3851 22.75 5.97089C22.75 5.55667 22.4142 5.22089 22 5.22089L22 6.72089ZM0.469669 5.44056C0.176777 5.73345 0.176777 6.20832 0.46967 6.50122L5.24265 11.2742C5.53554 11.5671 6.01041 11.5671 6.3033 11.2742C6.5962 10.9813 6.5962 10.5064 6.3033 10.2135L2.06066 5.97089L6.3033 1.72825C6.59619 1.43535 6.59619 0.960479 6.3033 0.667585C6.0104 0.374692 5.53553 0.374692 5.24264 0.667585L0.469669 5.44056ZM22 5.22089L0.999999 5.22089L1 6.72089L22 6.72089L22 5.22089Z" fill="#C8AA8E" />
                                    </svg>
                                </button>
                            </div>
                            <div className='arrow'>
                                <button onClick={() => handleArrowClick("right")}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="12" viewBox="0 0 23 12" fill="none">
                                        <path d="M1 5.22089C0.585786 5.22089 0.25 5.55667 0.25 5.97089C0.25 6.3851 0.585787 6.72089 1 6.72089L1 5.22089ZM22.5303 6.50122C22.8232 6.20832 22.8232 5.73345 22.5303 5.44056L17.7574 0.667587C17.4645 0.374693 16.9896 0.374693 16.6967 0.667587C16.4038 0.96048 16.4038 1.43535 16.6967 1.72825L20.9393 5.97089L16.6967 10.2135C16.4038 10.5064 16.4038 10.9813 16.6967 11.2742C16.9896 11.5671 17.4645 11.5671 17.7574 11.2742L22.5303 6.50122ZM1 6.72089L22 6.72089L22 5.22089L1 5.22089L1 6.72089Z" fill="#C8AA8E" fill-opacity="0.85" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className='virtual-tour-right-div'>
                        <Slider ref={sliderRef} {...settings}>
                            {carousles.map((slide, index) => (
                                <div key={index}>
                                    {index === currentIndex && (
                                        <iframe
                                            src={slide.image1}
                                            alt={slide.text}
                                            fallbackSrc={slide.image2}
                                            className='slider-image'
                                            frameBorder="0"
                                            allowFullScreen
                                            title="Virtual Tour"
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                                alert('Unable to load the virtual tour. Please check your connection or try another device.');
                                            }}

                                        />
                                        // <iframe
                                        //     src={slide.image}
                                        //     alt={slide.text}
                                        //     className="slider-image"
                                        //     frameBorder="0"
                                        //     allowFullScreen
                                        //     title="Virtual Tour"
                                        //     onError={(e) => {
                                        //         e.target.style.display = 'none';
                                        //         alert('Unable to load the virtual tour. Please check your connection or try another device.');
                                        //     }}
                                        // />

                                    )}
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VirtualTourBanner;
